export default {
  edition: {
    full: 'Edition',
    arabic: 'نسخة',
  },
  happenings: {
    full: 'Happenings',
    initial: 'H',
    rest: 'appenings',
    arabic: 'حدث وسيحدث',
    arabicInitial: 'ح',
    arabicRest: 'حدث وسيحدث',
  },
  theme: {
    full: 'Theme',
    initial: 'T',
    rest: 'heme',
    arabic: 'الفكرة',
  },
  workshops: {
    full: 'Workshops',
    initial: 'W',
    rest: 'orkshops',
    arabic: 'ورشات العمل',
  },
  people: {
    full: 'People',
    initial: 'P',
    rest: 'eople',
    arabic: 'الأشخاص',
  },
  location: {
    full: 'Location',
    initial: 'L',
    rest: 'ocation',
    arabic: 'المواقع',
  },
  projects: {
    full: 'Projects',
    initial: 'P',
    rest: 'rojects',
    arabic: 'مشاريع',
  },
  about: {
    full: 'About',
    initial: 'A',
    rest: 'bout',
    arabic: 'عن البرنامج',
  },
  contact: {
    full: 'Contact',
    initial: 'C',
    rest: 'ontact',
    arabic: 'تواصل',
  },
  support: {
    full: 'Support',
    initial: 'S',
    rest: 'upport',
    arabic: 'دعم',
  },
  related: {
    full: 'Related',
    initial: 'R',
    rest: 'elated',
    arabic: 'متعلقات',
  },
};


export const contentTypes = {
  opencall: 'دعوة مفتوحة',
  workshop: 'ورشة عمل',
  workshops: 'ورشات العمل',
  event: 'فعالية',
  events: 'فعاليات',
  announcement: 'إعلان',
  announcements: 'إعلانات',
  project: 'مشروع',
  projects: 'مشاريع',
  essay: 'مقال',
  essays: 'مقالات',
  support: 'الدعم',
  patrons: 'الداعمون',
  thankyou: 'شكر خاص',
  sponsors: 'الرعاة',
  participants: 'المشاركون',
  facilitators: 'الميسرون',
  team: 'الفريق',
  date: 'التاريخ',
  time: 'الوقت',
  location: 'الموقع',
};

export const event = {
  date: 'التاريخ',
  time: 'الوقت',
  location: 'الموقع',
};



// WEBPACK FOOTER //
// ./js/langMap.js